import React from "react"

import SelectMultiGenericNew from "../../../../../gd-ui/select-multi-generic-new/select-multi-generic-new"
import FieldStatus_MultiselectValueNotEmpty from "../../../../generic/status/components/multiselect/value-not-empty"
import FieldStatus_MultiselectPopoverOption from "../../../../generic/status/components/multiselect/option"
import ConditionTypeSelector from "../../../../proto/render/condition/condition-type-selector"
import FieldFormElementView from "../../../../render/form-elemnent-view"
import FieldsFactory from "../../../../fields-factory"
import FieldProto from "../../../../proto/field-proto"
import {FieldType} from "../../../../field-type"
import {ConditionType} from "../../../../../model2/conditions/condition-types"
import {FieldConditionFormProps} from "../../../../render/condition/@types"
import {
    getMomentConditionValueField,
    defaultMomentConditionValue,
} from "../../../../generic/datetime/moment/render/condition-value"

// Composite condition form: "status changed from X to Y within a date range".
// The condition value is { fromValues, toValues, dateType, dateValue }.
// - fromValues / toValues : reuse the status multiselect (empty = "Any")
// - dateType / dateValue  : the embedded date sub-condition. Its type->value-field mapping
//                           and per-type defaults come from the shared moment-condition
//                           helpers, so this stays identical to the automation date filter.
//
// Layout: from / to statuses on the first row, the date filter on a second row below.

// A throwaway date field only used to feed the date condition-type selector its options.
// Built lazily (inside the component) to avoid a circular-import crash: this module is
// pulled in through FieldsFactory, so FieldsFactory is undefined at module-eval time.
function getDateTypeSelectorField(): FieldProto {
    return FieldsFactory.get({
        type    : FieldType.TASK_MOMENT_CREATED,
        fieldId : 'statusChangedDateType',
    })
}

export default function FieldTaskStatusChanged_ConditionForm(props: FieldConditionFormProps) {

    // The value is materialized (defaults filled) at model level in Condition.set value, so here
    // it is always the complete composite object - the form only reads and patches it.
    const value = props.condition.value

    const {fromValues, toValues, dateType, dateValue} = value

    const update = (partial: any) => {
        props.condition.value = {
            ...value,
            ...partial,
        }
        props.onChangeCallback(props.condition.type, props.condition.value)
    }

    const onChangeFromValues = (newFromValues: any) => {
        update({
            fromValues: newFromValues
        })
    }
    const onChangeToValues = (newToValues: any) => {
        update({
            toValues: newToValues
        })
    }

    const onChangeDateType = (newDateType: ConditionType) => {
        update({
            dateType    : newDateType,
            dateValue   : defaultMomentConditionValue(newDateType)
        })
    }

    const onChangeDateValue = (newDateValue: any) => {
        update({
            dateValue: newDateValue
        })
    }

    const options               = gd.session.statuses.toOptions()
    const dateTypeSelectorField = getDateTypeSelectorField()
    const dateValueField        = getMomentConditionValueField(dateType)

    return (
        <div className="flex-column-left-top w-100p">

            <div className="flex-row-left-center w-100p">
                <div className="label w-150 nowrap fl-no-shrink">from</div>
                <div className="flex-1">
                    <SelectMultiGenericNew
                        className                       = "w-100p"
                        options                         = {options}
                        values                          = {fromValues}
                        allValuesOptionLabel            = "Any"
                        popoverScrollContainerClasses   = "max-h-200 max-w-300"
                        allValuesOption                 = {true}
                        isSearchable                    = {true}
                        valueComponent                  = {FieldStatus_MultiselectValueNotEmpty}
                        popoverOptionComponent          = {FieldStatus_MultiselectPopoverOption}
                        onChange                        = {onChangeFromValues}
                    />
                </div>

                <div className="label m-l-10 m-r-10">to</div>
                <div className="flex-1">
                    <SelectMultiGenericNew
                        className                       = "w-100p"
                        options                         = {options}
                        values                          = {toValues}
                        allValuesOptionLabel            = "Any"
                        popoverScrollContainerClasses   = "max-h-200 max-w-300"
                        allValuesOption                 = {true}
                        isSearchable                    = {true}
                        valueComponent                  = {FieldStatus_MultiselectValueNotEmpty}
                        popoverOptionComponent          = {FieldStatus_MultiselectPopoverOption}
                        onChange                        = {onChangeToValues}
                    />
                </div>
            </div>

            <div className="flex-row-left-center w-100p m-t-10">
                <div className="label w-150 nowrap fl-no-shrink">moment of change</div>
                <ConditionTypeSelector
                    field       = {dateTypeSelectorField}
                    value       = {dateType}
                    onChange    = {onChangeDateType}
                />

                {dateValueField &&
                    <div className="flex-row-left-center fl-no-shrink m-l-8 w-250">
                        <FieldFormElementView
                            className   = "w-100p"
                            field       = {dateValueField}
                            model       = {{value: dateValue}}
                            onChange    = {onChangeDateValue}
                        />
                    </div>
                }
            </div>
        </div>
    )
}
